const GoalStatuses = ['Ahead of Schedule', 'On Track', 'Has Issues', 'At Risk', 'Delayed'];

export default GoalStatuses;
